import template from './switch-component.html';

class Switch {

  $onInit() {
    this.model.$render = () => {
      this.value = this.model.$modelValue;
    };
  }

  toggle() {
    if (this.isDisabled || this.isReadonly) {
      return;
    }

    this.value = !this.value;
    this.model.$setViewValue(this.value);
    this.model.$setTouched();
  }

}

const SwitchComponent = {
  require: {
    model: 'ngModel'
  },
  bindings: {
    // TODO: this should really use ng-disabled and ng-readonly
    isDisabled: '<',
    isReadonly: '<'
  },
  controller: Switch,
  template
};

export default SwitchComponent;

